import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { spacing, breakpoints } from 'styles/globals';
import TopicCard from 'components/TopicCard';
import { TOPIC_CARD } from 'utils/image/getPictureUrl';
import InlineList from 'components/InlineList';
import Button from 'components/Button';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TopicGridItem = styled.li.attrs({
  role: 'listitem'
}).withConfig({
  displayName: "TopicList__TopicGridItem",
  componentId: "sc-30qcyf-0"
})(["display:flex;flex-shrink:0;align-items:flex-start;width:50%;@media (min-width:", "){width:25%;}@media (min-width:", "){width:20%;}@media (min-width:", "){width:16.666%;}"], breakpoints.xxs, breakpoints.s, breakpoints.m);
var TopicGrid = styled.ul.attrs({
  role: 'list'
}).withConfig({
  displayName: "TopicList__TopicGrid",
  componentId: "sc-30qcyf-1"
})(["display:flex;flex-wrap:wrap;margin-left:-", ";margin-bottom:-", ";& > ", "{padding-left:", ";padding-bottom:", ";}@media (min-width:", "){margin-left:-", ";margin-bottom:-", ";& > ", "{padding-left:", ";padding-bottom:", ";}}"], spacing.s, spacing.xs, TopicGridItem, spacing.s, spacing.xs, breakpoints.s, spacing.m, spacing.s, TopicGridItem, spacing.m, spacing.s);
function TopicList(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'tiles' : _ref$variant,
    _ref$withBrowseButton = _ref.withBrowseButton,
    withBrowseButton = _ref$withBrowseButton === void 0 ? false : _ref$withBrowseButton;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (items.length === 0) {
    return null;
  }
  if (variant === 'buttons') {
    return /*#__PURE__*/_jsxs(InlineList, {
      spacing: "s",
      children: [items.map(function (topic) {
        return /*#__PURE__*/_jsx(Button, {
          as: NavLink,
          to: "/browse/".concat(topic.id),
          variant: "shaded",
          children: topic.name
        }, topic.id);
      }), withBrowseButton && /*#__PURE__*/_jsx(Button, {
        round: true,
        variant: "shaded",
        iconRight: "arrow-right",
        as: NavLink,
        to: "/browse",
        children: t('actions_browse_all_playlists')
      })]
    });
  }
  return /*#__PURE__*/_jsxs(TopicGrid, {
    children: [items.map(function (topic) {
      return /*#__PURE__*/_jsx(TopicGridItem, {
        children: /*#__PURE__*/_jsx(TopicCard, {
          as: NavLink,
          to: "/browse/".concat(topic.id),
          id: "filter_".concat(topic.name),
          icon: "topic",
          imageSrc: topic.pictureUrl && "".concat(topic.pictureUrl, "/").concat(TOPIC_CARD),
          children: topic.name
        })
      }, topic.id);
    }), withBrowseButton && /*#__PURE__*/_jsx(TopicGridItem, {
      children: /*#__PURE__*/_jsx(Button, {
        fullWidth: true,
        as: NavLink,
        to: "/browse",
        align: "left",
        variant: "shaded",
        iconRight: "arrow-right",
        size: "large",
        mt: 26,
        children: t('actions_browse_all_playlists')
      })
    }, "browse-all")]
  });
}
export default TopicList;